<template>
  <el-dialog
    width="50%"
    class="dialog"
    title="旧机详情"
    :visible.sync="dialogFormVisible"
  >
    <div class="module-wrap">
      <el-descriptions title="基础信息" :column="2" class="common-description-border">
        <el-descriptions-item label="项目编号">{{
          detailInfo.projectNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="项目明细行编号">{{
          detailInfo.projectDetailNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机品牌">{{
          detailInfo.brandName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机系列">{{
          detailInfo.category || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机冷量">{{
          detailInfo.coolNum || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机年限">{{
          detailInfo.useAge || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="明细行旧机数量">{{
          detailInfo.detailRecycleTotal || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="是否拆机">{{
          detailInfo.disassemble === 0 ? "否" : "是"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机楼层">{{
          detailInfo.floorNum || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="安装环境描述">{{
          detailInfo.enDesc || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机状态">{{
          detailInfo.oldMachineStatusStr
        }}</el-descriptions-item>
        <el-descriptions-item label="明细行回收价">{{
          detailInfo.detailRecyclePrice || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="条码">{{
          detailInfo.barCode || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="报价单">
          <el-link
            v-if="detailInfo.reportPriceUrl"
            type="text"
            @click="downloadQuoteFile(detailInfo)"
            class="report-price-url"
          >
            {{ detailInfo.reportPriceUrl || "--" }}
          </el-link>
        </el-descriptions-item>
        <el-descriptions-item label="单价">{{
          detailInfo.singlePrice || "--"
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="铭牌照片" :column="1"> </el-descriptions>
      <div class="img-wrap">
        <image-upload
          class="img-box"
          v-for="(item, index) in detailInfo.nameplatePhotos"
          :key="index"
          :imageUrl.sync="item.annexId"
          :editMode="false"
        />
      </div>
      <el-descriptions title="安装环境图片" :column="1"> </el-descriptions>
      <div class="img-wrap">
        <image-upload
          class="img-box"
          v-for="(item, index) in detailInfo.installationPhotos"
          :key="index"
          :imageUrl.sync="item.annexId"
          :editMode="false"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getOldMachineDetail } from "@/api/COldForNew";
import imageUpload from "./ImageUpload";
import enumMixin from "../enumMixin";

export default {
  components: { imageUpload },
  data() {
    return {
      dialogFormVisible: false,
      detailInfo: {
        nameplatePhotos: [],
        installationPhotos: []
      }
    };
  },
  mixins: [enumMixin],
  computed: {
    baseUrl() {
      return process.env.BASE_API;
    }
  },
  methods: {
    closeDialog() {
      this.dialogFormVisible = false;
    },
    async openDialog(id) {
      const { data, statusCode } = await getOldMachineDetail(id);
      if (statusCode === 200) {
        this.detailInfo = data;
        this.detailInfo.nameplatePhotos = data.oldMachineAnnexeList.filter(
          item => item.annexType === 100
        );

        this.detailInfo.installationPhotos = data.oldMachineAnnexeList.filter(
          item => item.annexType === 101
        );

        for (const photo of this.detailInfo.installationPhotos) {
          photo.annexId = await this.changeImg(photo.annexId);
        }
        for (const photo of this.detailInfo.nameplatePhotos) {
          photo.annexId = await this.changeImg(photo.annexId);
        }

      }
      this.dialogFormVisible = true;
    },
    async changeImg(imgUrl) {
      if (imgUrl) {
        const response = await this.axios({
          url: `${this.baseUrl}/autoapp-default-server-recovery/api/sms-annex/download-file?fileId=${imgUrl}`,
          method: "GET",
          headers: { Authorization: this.$store.getters.token }
        });
        return response.request.responseURL;
      }
    },
    async downloadQuoteFile(row) {
      const url = `${this.baseUrl}/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${row.reportPriceUrl}`;
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .report-price-url {
    color: #00b882;
    font-size: 12px;
  }
  .img-wrap {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    > .img-box {
      margin: 0 10px 20px 0;
    }
  }
  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/components/searchOldDetailDialog.vue